module.exports = __webpack_public_path__ + "static/media/011_personalinformation@2x.292fdc7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/011_personalinformation@2x.png
// module id = 574
// module chunks = 0